import createTemplateService from './createTemplateServjce';
const researcherNonConfidentialTemplateService = createTemplateService('/researcher_non_confidential_templates');
export default researcherNonConfidentialTemplateService;